import { LocalRepository } from "@shared/helper/local-repository";
import { THEME } from "constants/storage-keys";

export const setTheme = (repo: LocalRepository) => {
    const theme = repo.getCookieItem(THEME);
    const html = repo.getDocument.getElementsByTagName('html')[0];
    if (html) {
      if (theme) {
        if (theme === 'light') {
          html.classList.remove('dark');
          html.classList.add(theme);
        }
        else {
          html.classList.remove('light');
          html.classList.add(theme);
        }
      }
      else {
        html.classList.add("light");
      }
    }
}